import _Link from './Link'
import _IndexLink from './IndexLink'

export const Link = _Link
export const IndexLink = _IndexLink
